import { render, staticRenderFns } from "./RegistrationUserValid.vue?vue&type=template&id=4423c3f4&"
import script from "./RegistrationUserValid.vue?vue&type=script&lang=js&"
export * from "./RegistrationUserValid.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationUserValid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports